import React from "react"
import styled from "styled-components"

const StyledAlign = styled.div`
  text-align: ${props => props.align};
  width: 100%;
`

const TextAlign = ({content = "", align = "left"}) => {
    return <StyledAlign align={align}>{content}</StyledAlign>
}

export default TextAlign
